var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"number-input",attrs:{"value":_vm.value},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }